import http from "../../../../../../../core/utils/apis/skillApi";

const BASE = "/evaluation-questions";

export const EvaluationQuestionService = {
  create: (data) => http.post(BASE, data),
  getAll: () => http.get(BASE),
  getById: (id) => http.get(`${BASE}/${id}`),
  update: (id, data) => http.patch(`${BASE}/${id}`, data),
  remove: (id) => http.delete(`${BASE}/${id}`),
  getByForm: (formId) => http.get(`${BASE}/form/${formId}`),
  getGroupedByForm: (formId) => http.get(`${BASE}/grouped/${formId}`),
  getSkillsList: (params = {}) => http.get("/skills", { params }),
};
